<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  const dispatch = createEventDispatcher<{ signin: void }>();

  export let message: string | null = null;
</script>

<section class="landing">
  <div class="landing__field" aria-hidden="true">
    <span class="landing__ring landing__ring--outer"></span>
    <span class="landing__ring landing__ring--mid"></span>
    <span class="landing__ring landing__ring--inner"></span>
    <span class="landing__core"></span>
  </div>

  <h1 class="landing__wordmark">Gravity</h1>
  <p class="landing__line">Tickets and invites for our community events.</p>

  {#if message}
    <p class="landing__message">{message}</p>
  {/if}

  <button type="button" class="accent landing__enter" on:click={() => dispatch('signin')}>Enter</button>
</section>

<style>
  .landing {
    min-height: 100svh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--space-4);
    padding: var(--space-6);
    text-align: center;
  }

  .landing__field {
    position: relative;
    width: clamp(160px, 28vmin, 240px);
    height: clamp(160px, 28vmin, 240px);
    margin-bottom: var(--space-4);
  }

  .landing__ring {
    position: absolute;
    inset: 0;
    border-radius: 50%;
    border: 1px solid rgba(244, 241, 232, 0.14);
  }

  .landing__ring--mid {
    inset: 18%;
    border-color: rgb(var(--accent-rgb) / 0.28);
  }

  .landing__ring--inner {
    inset: 36%;
    border-color: rgb(var(--accent-rgb) / 0.45);
  }

  .landing__core {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 10px;
    height: 10px;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    background: var(--color-accent-amber-500);
    box-shadow: 0 0 24px 6px var(--color-accent-amber-glow);
  }

  .landing__wordmark {
    margin: 0;
    font-family: var(--font-display);
    font-size: clamp(2.4rem, 8vw, 3.6rem);
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: var(--color-text-primary);
  }

  .landing__line {
    margin: 0;
    max-width: 34ch;
    color: var(--color-text-secondary);
    font-size: var(--font-size-md);
    line-height: var(--line-height-relaxed);
  }

  .landing__message {
    margin: 0;
    max-width: 40ch;
    color: var(--color-text-amber);
    font-size: var(--font-size-sm);
  }

  .landing__enter {
    margin-top: var(--space-3);
    min-width: 180px;
    font-size: var(--font-size-md);
  }
</style>
